import type { Theme } from "@/lib/theme/type";

export const DEFAULT_THEME: Theme = {
  color: {
    black: "#333333",
    white: "#ffffff",
    neutral: {
      25: "#f9f9f9",
      50: "#f2f2f2",
      100: "#e6e6e6",
      200: "#cccccc",
      300: "#b3b3b3",
      400: "#999999",
      500: "#808080",
      600: "#666666",
      700: "#4d4d4d",
      800: "#333333",
      900: "#1a1a1a",
    },
    brand: {
      25: "#f5f6fa",
      50: "#ebeefc",
      100: "#d6e5fa",
      200: "#bfd5fd",
      300: "#5a9fdc",
      400: "#4693d7",
      500: "#3187D3",
      600: "#2c7abe",
      700: "#276ca9",
      800: "#225f94",
      900: "#1d517f",
    },
    primary: "#17254f",
    secondary: "#2059e9",
    tertiary: "#f5f6fa",
    placeholder: "#d6e5fa",
    txt: {
      primary: "#17254f",
      secondary: "#62748E",
      tertiary: "#90A1B9",
      placeholder: "#adadad",
      inverted: "#ffffff",
      brand: "#3187D3",
    },
    surface: {
      background: "#ffffff",
      primary: "#f5f6fa",
      secondary: "#E6EDF5",
      tertiary: "#f5f5f5",
      inverted: "#17254f",
      modal: "#ffffff",
      neutral: "#fafafa",
      brand: { primary: "#F2F7FD", secondary: "#E1ECF9" },
    },
    bordercolor: {
      primary: "#ebebeb",
      secondary: "#17254f",
      tertiary: "#cccccc",
      inverted: "#ffffff",
      modal: "#e0e0e0",
      neutral: "#f0f0f0",
      brand: "#3187D3",
    },
    red: {
      25: "#fff5f5",
      50: "#ffe3e3",
      100: "#ffc9c9",
      200: "#ffa8a8",
      300: "#ff8787",
      400: "#ff6b6b",
      500: "#ff4f4f",
      600: "#ff3d3d",
      700: "#e83636",
      800: "#cf2e2e",
      900: "#b82424",
    },
    error: {
      10: "#fff5f5",
      20: "#fee4e2",
      80: "#f97066",
      100: "#f04438",
    },
    warning: {
      10: "#fffaeb",
      20: "#fef0c7",
      80: "#fdb022",
      100: "#f79009",
    },
    success: {
      10: "#ecfdf3",
      20: "#B7E2CE",
      80: "#32d583",
      100: "#109E5B",
    },
  },
} as const;
